module.exports = __webpack_public_path__ + "static/media/hospital3.5c944f24.webp";